import React, { useEffect, useState } from "react";
import {Table, Row, Col, Card, CardBody, Modal, CardTitle, ModalHeader, ModalBody, FormGroup, Label, InputGroup, Button} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import moment from "moment";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { PhoneInput } from 'react-international-phone';
import { json, Link } from "react-router-dom";
const Users = () => {
  document.title = "AMAVIE | Application de gestion de Afrika Mobility";
  const [loadingBord, setLoadingBord]=useState(false)
  const [users, setUsers]= useState([])
  const [companies, setCompanies]= useState([])
  const [total, setTotal]=useState(0)
  const [totalPage, setTotalPage]= useState(0)
  const [currPage, setCurrPage]= useState(0)
  const [user, setUser]= useState(null)
  const [password, setPassword]= useState("12345")
  const [company, setCompany]= useState(null)
  const [search, setSearch]= useState(null)
  const [currAttestation, setCurrAttestation]= useState(null)
  const [modal_detail_beneficiary, setmodal_detail_beneficiary] = useState(false);
  const [modal_beneficiary, setmodal_beneficiary] = useState(false);
  const [erroruser, setErroruser]= useState(null)
  const [successuser, setSuccessuser]= useState(null)
  const [sq1, setsq1] = useState(false);
  //FOR user FORM
  const [userLastName, setUserLastName]= useState("")
  const [userFirstName, setUserFirstName]= useState("")
  const [userPhone, setUserPhone]= useState("")
  const [userEmail, setUserEmail]= useState(null)
  const [userCountries, setUserCountries]= useState([])

  const checkuserInput = () => {
    if (!company || company==null || company==undefined) { setErroruser('Veuillez entrer le nom de l\'utilisateur svp'); return false;}
    if (!userLastName || !userLastName.trim()) { setErroruser('Veuillez entrer le nom de l\'utilisateur svp'); return false;}
    if (!userFirstName || !userFirstName.trim()) { setErroruser('Veuillez entrer le prénom de l\'utilisateur svp'); return false;}
    if (!userPhone || !userPhone.trim()) { setErroruser('Veuillez entrer le téléphone de l\'utilisateur svp'); return false;}
    if (!userEmail || !userEmail.trim()) { setErroruser('Veuillez entrer le mail de l\'utilisateur svp'); return false;}
      setErroruser("")     
      return true;
  };
  const tog_detail_beneficiary = (data) => {
    setCurrAttestation(data)
    setmodal_detail_beneficiary(!modal_detail_beneficiary);
    removeBodyCss();
  };
  const tog_user = () => { setmodal_beneficiary(!modal_beneficiary); removeBodyCss(); };
  const removeBodyCss = () => { document.body.classList.add("no_padding"); };

  const loadUsers=(page, search)=> {
    setLoadingBord(true)
    fetch(`${url.BACKEND_URL}/users?page=${page}&size=20`, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => {
      console.log(responseJson);

      if (responseJson.status==200) {
        setUsers(responseJson.data)
        setTotal(responseJson.total_element)
        setTotalPage(responseJson.total_page)
        setCurrPage(responseJson.page)
        setLoadingBord(false)
    } else { setUsers([]); setLoadingBord(false) }
    }) .catch((error) => { setLoadingBord(false) });
  };

  const loadCountries=()=> {
    fetch(`${url.BACKEND_URL}/countries`, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => {         
      if (responseJson.status==200) { 
        setUserCountries(responseJson.data.map(item=>({label: item.name, value: item.id }))); 
      } 
      else { setUserCountries([]); setLoadingBord(false) }
    }) .catch((error) => { setLoadingBord(false) });
  };

  const loadCompanies=()=> {
    fetch(`${url.BACKEND_URL}/companies`, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => {         
      if (responseJson.status==200) { setCompanies(responseJson.data.map(item=>({label: item.name, value: item.id}))); } 
      else { setCompanies([]); setLoadingBord(false) }
    }) .catch((error) => { setLoadingBord(false) });
  };
    
  const saveUser= ()=>{
    const inputError = checkuserInput();
    if (inputError) {
      const now = new Date().toISOString();
      const jsonData= JSON.stringify({ company: {id: company.value}, last_name: userLastName, first_name: userFirstName, phone: userPhone, password: password, state: 1, email: userEmail, roles: [{id: 1}, {id: 2}] });
      console.log("User Info to send", jsonData);
      // setLoader(true)
      fetch(`${url.BACKEND_URL}/users`, { method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: jsonData })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log("User Saved", responseJson.data);
        if (responseJson.status==200) { 
          setUsers([responseJson.data, ...users]);
        }
        else { setErroruser(responseJson.message) }
      }) .catch((error) => { console.log(error); }); 
    }
  }
  
  const changeStateUser= (user)=>{
    // alert(user);
    fetch(`${url.BACKEND_URL}/users/change-state/${user}`, { method: 'PUT',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' }})
      .then((response) => response.json())
      .then((responseJson) => {
        console.log("User Saved", responseJson.data);
        if (responseJson.status==200) { loadUsers(0, null); }
        else { setErroruser(responseJson.message) }
      }) .catch((error) => { console.log(error); }); 
  }

  useEffect(()=>{ loadUsers(0, null); loadCompanies(); loadCountries() }, [])
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="AMAVIE" title="Utilisateurs" />
          <Modal isOpen={modal_beneficiary} toggle={tog_user} size="lg">
            <ModalHeader className="mt-0" toggle={tog_user}>Formulaire de création d'un utilisateur</ModalHeader>
            <ModalBody>
              <form>
                <Row>
                  <Col lg="4">
                    <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                      <Label>Entreprise partenaire</Label>
                      <Select
                        value={company} 
                        isMulti={false}
                        onChange={(selected) => { setCompany(selected); }}
                        options={companies} 
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Nom</Label>
                      <input className="form-control" onChange={(event)=>{ setUserLastName(event.target.value); }}placeholder="Nom de l'utilisateur" type="text" id="example-datetime-local-input"/>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Prénoms</Label>
                      <input className="form-control" onChange={(event)=>{ setUserFirstName(event.target.value); }} placeholder="Prénoms de l'utilisateur" type="text" id="example-datetime-local-input"/>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="mb-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="formrow-firstname-input">Numéro de téléphone</label>
                        <PhoneInput
                          defaultCountry="ci"
                          value={userPhone}
                          onChange={setUserPhone}
                          inputStyle={{ width: "100%" }} 
                          />
                      </div>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Label>Email</Label>
                      <input className="form-control" placeholder="Email de l'utilisateur" onChange={(event)=>{ setUserEmail(event.target.value); }} type="text" id="example-datetime-local-input"/>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ marginTop: 20}}>
                    <strong className="text-danger">{erroruser}</strong>
                    <strong className="text-success">{successuser}</strong>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ marginTop: 20}}>
                    <Button color="primary" style={{ fontSize: 20  }} className="form-control btn btn-primary waves-effect waves-light" onClick={()=>saveUser()}>Ajouter l'utilisateur</Button>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>

          <Row>
            <CardTitle className="h4">Gestion des utilisateurs</CardTitle>
            <Col md={6}>
              <div className="mb-3">
                <Label>Recherche</Label>
                <input className="form-control" placeholder="Rechercher un utilisateur..." onChange={(event)=>{ setSearch(event.target.value); loadUsers(0, event.target.value); }} type="text" defaultValue="" id="example-datetime-local-input"/>
              </div>
            </Col>
            <Col md={3}>

            </Col>
             <Col xl={3}>
                <Label style={{ visibility: "hidden" }}>--</Label>
                <Link color="primary" onClick={tog_user} className="form-control btn btn-warning waves-effect"><i className="fas fa-user-plus"></i> Créer un utilisateur</Link>
              </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  {/* <p className="card-title-desc">
                    Use one of two modifier className to make{" "}
                    <code>&lt;thead&gt;</code>s appear light or dark gray.
                  </p> */}

                {/*MODAL POUR VISUALISER L'ATTESTATION*/}
                <Modal isOpen={modal_detail_beneficiary} toggle={tog_detail_beneficiary} size="lg">
                    <ModalHeader className="mt-0" toggle={tog_detail_beneficiary}>Large Modal</ModalHeader>
                    <ModalBody>
                      <p>
                        <strong>
                          {currAttestation?.zone?.name} Heuss
                        </strong>
                      </p>
                      <p>Praesent commodo cursus magna, vel scelerisque
                        nisl consectetur et. Vivamus sagittis lacus vel
                        augue laoreet rutrum faucibus dolor auctor.</p>
                      <p className="mb-0">Aenean lacinia bibendum nulla sed consectetur.
                        Praesent commodo cursus magna, vel scelerisque
                        nisl consectetur et. Donec sed odio dui. Donec
                        ullamcorper nulla non metus auctor
                        fringilla.</p>
                    </ModalBody>
                  </Modal>
                  <div className="table-responsive">
                    <Table className="table mb-0" style={{fontSize: 13}}>
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Entreprise</th>
                          <th>Nom et prénoms</th>
                          <th>Contact</th>
                          <th>Email</th>
                          <th>Etat</th>
                        </tr>
                      </thead>
                      <tbody>
                         {users.map((item, key)=>(
                            <tr key={key}>
                              <td>{item?.id}</td>
                              <td>{item?.company?.name}</td>
                              <td>{item?.first_name} {item?.last_name}</td>
                              <td>{item?.phone}</td>
                              <td>{item?.email}</td>
                              <td>
                                <div className="square-switch">
                                  <input
                                    type="checkbox"
                                    id={`square-switch${item?.id}`}
                                    switch="none"
                                    checked={item.state==0 ? false: true}
                                    onChange={() => { changeStateUser(item?.id) }}
                                  />
                                  <label
                                    htmlFor={`square-switch${item?.id}`}
                                    data-on-label="ON"
                                    data-off-label="OFF"
                                  />
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>

                  {/* Pagination Controls */}
                  {users.length > 0 && (
                    <Row className="mt-3">
                      <Col lg={12}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <p className="mb-0">
                              Affichage de {users.length} utilisateurs sur {total} au total
                            </p>
                          </div>
                          <div className="d-flex gap-2 align-items-center">
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => loadUsers(currPage - 1, search)}
                              disabled={currPage === 0 || loadingBord}
                            >
                              <i className="fas fa-chevron-left"></i> Précédent
                            </Button>
                            <span className="mx-2">
                              Page {currPage + 1} sur {totalPage}
                            </span>
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => loadUsers(currPage + 1, search)}
                              disabled={currPage >= totalPage - 1 || loadingBord}
                            >
                              Suivant <i className="fas fa-chevron-right"></i>
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Users;
